import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetData,
  type GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetError,
  type GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetResponse,
  getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGet,
} from '../../generated';

export type GetIcpProductCategoryQueryVariables =
  GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetData['path'];

export type GetIcpProductCategoryQuery = GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetResponse;

export const useGetIcpProductCategoryQuery = <
  TData = GetIcpProductCategoryQuery,
  TError = GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetError,
>(
  { icp_product_category_id }: GetIcpProductCategoryQueryVariables,
  options?: Omit<UseQueryOptions<GetIcpProductCategoryQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<GetIcpProductCategoryQuery, TError, TData>({
    queryKey: ['GetIcpProductCategory', { icp_product_category_id }],
    queryFn: async () => {
      const { data } = await getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGet({
        path: { icp_product_category_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useGetIcpProductCategoryQuery.getKey = ({ icp_product_category_id }: GetIcpProductCategoryQueryVariables) => [
  'GetIcpProductCategory',
  { icp_product_category_id },
];

useGetIcpProductCategoryQuery.fetcher = (
  { icp_product_category_id }: GetIcpProductCategoryQueryVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGet({
      path: { icp_product_category_id },
      throwOnError: true,
    });
    return data;
  };
};
